export function DueDateMessageFilter(gettextCatalog) {
    return function createDueDateMessage(daysUntilDue:number):string {
        if (isNaN(daysUntilDue)) {
            throw new Error('DueDateMessageFilter takes parameter of type number');
        } else {
            daysUntilDue = Math.ceil(daysUntilDue);
        }

        let ret = '';

        if (daysUntilDue === 1) {
            ret = gettextCatalog.getString('Due today');
        } else if (daysUntilDue === 0) {
            ret = gettextCatalog.getString('Overdue');
        } else if (daysUntilDue <= -1) {
            let numDays = Math.abs(daysUntilDue);

            // 2 calls to getString instead of 1 to getPlural needed for Japanese localization quirk
            ret = numDays === 1 ?
                gettextCatalog.getString('Overdue by {{d}} day', {d: numDays}) : 
                gettextCatalog.getString('Overdue by {{d}} days', {d: numDays});
        } else if (daysUntilDue > 1) {
             ret = gettextCatalog.getString('Due in {{d}} days', {d: daysUntilDue});
    
        }

        return ret;
    }
}

DueDateMessageFilter.$inject = [
	'gettextCatalog'
];


// WEBPACK FOOTER //
// ./src/sharebase/filters/dueDateMessage.ts